import React from 'react';
import { useDispatch } from 'react-redux';

import { dashboardClienteAction } from "components/ApplicationInsights/eventNames";
import TrackingSlider from 'components/TrackingSlider';
import { MenuItem } from "..";

import tracking from 'img/menu-icon-tracking.svg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss';

import { IMenuItem } from '../interface';

interface IProps {
  itemComponent: React.FC<IMenuItem>,
  clickAction?: Function;
}

const Tracking: React.FC<IProps> = (props: IProps) => {
  const { itemComponent, clickAction } = props;

  const dispatch = useDispatch();

  const defaultClickAction = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'Comprovante de entrega',
        subtitle:
          'Utilize os campos abaixo para localizar o seu pedido.',
        show: true,
        content: TrackingSlider,
      },
    });
  };

  return React.createElement(itemComponent, {
    title: "COMPROVANTE",
    subtitle: "DE ENTREGA",
    icon: tracking,
    trackName: dashboardClienteAction.DASHCLIENTE_COMPROVANTEENTREGA,
    onClick: () => clickAction ? clickAction() : defaultClickAction(),
    id: "tracking-menu-item"
  });
};

export default Tracking;